import { useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Button, Input, Form } from "antd";
import { Warning2 } from "iconsax-react";
import PageHeader from "../../../components/PageHeader";

import { useStudent } from "../../../hooks/student";

import { useAuth } from "../../../hooks/auth";

import { Container, Main } from "./styles";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";

function StudentForm() {
  const { createStudent, loadingStudent } = useStudent();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user && user.type !== "admin" && !user.isAdmin) {
      navigate("/403");
    }
  }, [user, navigate]);

  interface FormProps {
    uid?: string;
    name: string;
    email: string;
  }
  const path = state.id;
  const handleAddStudent = useCallback(
    async ({ name, email }: FormProps) => {
      await createStudent({
        name,
        email,
        path,
      });
    },
    [createStudent, path]
  );

  return (
    <Container id="page-teacher-form">
      <PageHeader
        title="Adicionar novo aluno."
        description="Preencha o formulário abaixo para continuar"
        type="private"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Alunos", link: "/students" },
            { label: "Cadastro", active: true },
          ]}
        />
        <Form onFinish={handleAddStudent}>
          <fieldset>
            <legend>Dados do aluno</legend>

            <div className="InputBlock">
              <Form.Item
                label="Nome"
                name="name"
                rules={[{ required: true, message: "O nome é obrigatório!" }]}
              >
                <Input
                  id="name"
                  name="name"
                  placeholder="Insira o nome completo"
                />
              </Form.Item>
            </div>

            <div className="InputBlock">
              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, message: "O Email é obrigatório!" }]}
              >
                <Input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="Insira o Email"
                />
              </Form.Item>
            </div>
          </fieldset>
          <footer>
            <p>
              <Warning2 size={48} />
              Atenção! <br />É necessário preecher todos os dados.
            </p>
            <Button htmlType="submit" disabled={loadingStudent}>
              Salvar cadastro
            </Button>
          </footer>
        </Form>
      </Main>
      <Footer />
    </Container>
  );
}

export default StudentForm;
